"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpCurriculumImage: {
        em: 'Eureka Math',
        ww: 'Wit And Wisdom',
        phd: 'PhD',
        geo: 'Geodes',
        Other: 'other',
    },
};
